import React, { useRef } from 'react';
import Spline from '@splinetool/react-spline';
// import { useNavigate } from 'react-router-dom';

const Home = () => {
  // const navigate = useNavigate();
  const spline = useRef();

  function onLoad(splineApp) {
    spline.current = splineApp;
    // console.log('Spline loaded. Objects:', splineApp.getAllObjects());

    // "Hack": Try to find the text object and scale it up
    // Common names for text objects in Spline are "Text", "Text 2", or the text content itself.
    // We try a few common guesses or look for a specific type if possible.
    const possibleNames = ['Text', 'EL Ceballos', 'Title', 'Group'];
    
    let targetObj = null;
    for (const name of possibleNames) {
      targetObj = splineApp.findObjectByName(name);
      if (targetObj) break;
    }

    // If we found something, let's scale it!
    if (targetObj) {
      console.log('Found object to scale:', targetObj.name);
      // scaling up by 2.5x as an initial guess
      targetObj.scale.x *= 2.5;
      targetObj.scale.y *= 2.5;
      targetObj.scale.z *= 2.5;
    } else {
      console.log('Could not find a standard text object to scale. Check console for object names.');
    }
  }

  return (
    <div className="relative w-full h-screen bg-neutral-900 overflow-hidden">
      <Spline 
        scene="https://prod.spline.design/0MzQAraGbIcRPW-4/scene.splinecode"
        onLoad={onLoad}
      />
      
      {/* Enter Button Overlay */}
      {/* <div className="absolute bottom-10 left-0 right-0 text-center pointer-events-none">
        <button 
          onClick={() => navigate('/about')}
          className="pointer-events-auto text-white/50 text-sm tracking-[0.3em] uppercase hover:text-white transition-colors duration-300 animate-pulse hover:animate-none"
        >
          Enter Site
        </button>
      </div> */}
    </div>
  );
};

export default Home;
